import React, { Component } from 'react';
import { connect } from 'react-redux';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';
import { compose } from 'redux';

import Routes from './Routes';
import Footer from './Footer';
import {
	fetchInitData,
	fetchReservationData,
} from '../store/actions';
import { postMessageToParent } from '../utils';
import Error from './Error';
import LanguageSetter from "./LanguageSetter";

class App extends Component {

	constructor(props) {
		super(props);

		this.state = {
			didErrorOccurred: false,
			recaptcha: null,
			recaptchaToken: '',
			stylesInjected: false,
			langLoaded: false,
			resizeSensorInitialized: false,
		};
	}

	async componentDidMount() {
		try {
			await this.props.dispatch(fetchInitData());
			this.setState({stylesInjected: true});

		} catch (e) {
			console.error("Nepodařilo se načíst inicializační data.", e);
			this.setState({didErrorOccurred: true});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.stylesInjected && this.state.langLoaded && (!prevState.stylesInjected || !prevState.langLoaded)) {
			this.props.dispatch(fetchReservationData());
		}
	}

	componentDidCatch(error, info) {
		this.setState({ didErrorOccurred: true });
	}

	setLangLoaded = () => {
		this.setState({ langLoaded: true });
	};

	setRecaptcha = (recaptcha) => {
		this.setState({ recaptcha });
	};

	recaptchaDidResolve = (recaptchaToken) => {
		this.setState({ recaptchaToken });
	};

	initResizeSensor = (el) => {
		if (el && !this.state.resizeSensorInitialized) {
			this.setState({ resizeSensorInitialized: true });
			this.appContainerEl = el;
			new ResizeSensor(el, this.onResize);
		}
	};

	onResize = () => {
		if (this.appContainerEl) {
			postMessageToParent('resize', this.appContainerEl.scrollHeight);
		}
	};

	render() {
		if (this.state.didErrorOccurred) return <Error />;

		return (
			<div>
				<LanguageSetter setLangLoaded={this.setLangLoaded} />
				{this.state.stylesInjected && this.state.langLoaded &&
				<div className="app-container" ref={el => this.initResizeSensor(el)}>
					<Routes
						recaptcha={this.state.recaptcha}
						recaptchaToken={this.state.recaptchaToken}
					/>
					<Footer
						setRecaptcha={this.setRecaptcha}
						recaptchaDidResolve={this.recaptchaDidResolve}
					/>
				</div>
				}
			</div>
		);
	}
}

export default compose(
	connect(state => ({
		langLoaded: state.app.langLoaded,
	})),
)(App);



// WEBPACK FOOTER //
// ./src/components/App.jsx